import React, { useState, useEffect } from "react";

import "../sidebar.css";
import { Table, Container } from "react-bootstrap";
import AddInput from "./AddInput";
import axios from "axios";
import { Configs } from "../api";

const AdminTable = () => {
  const [locData, setdata] = useState([]);
  const [catID, setcatID] = useState("");

  useEffect(() => {
    loaddata();
  }, []);

  const loaddata = async () => {
    try {
      const result = await axios.get(Configs.specialdeal);
      // console.log('ppppppppppppppppppppp')
      // console.log(result.data.ingredients)
      // console.log(result.data.item);

      if (result.data.specialdeals.length !== null) {
        setdata(result.data.specialdeals);
        console.log(result.data.specialdeals);
      } else {
        console.log("null");
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const deleteTodo = async (id) => {
    // console.log(id)
    try {
      const deleteTodo = await axios.delete(Configs.specialdeal + "/" + id);
      setdata(locData.filter((todo) => todo._id !== id));
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <Container className="table-cont">
      <AddInput />

      <Table className="table-css" striped bordered hover>
        <thead>
          <tr>
            <th>Price</th>

            <th>Items</th>

            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {locData.map((todo) => (
            <tr key={todo._id}>
              <td>{todo.price}</td>

              <td>
                {todo.items
                  ? todo.items.map((itm) => (
                      <p key={itm._id}>
                        {itm.name ? itm.name : "item deleted"},
                      </p>
                    ))
                  : "Items Deleted"}
              </td>

              <td>
                <button
                  className="btn btn-danger"
                  onClick={(e) => deleteTodo(todo._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminTable;
